import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
        Loading admin...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-signin" replace />;
  }

  return children;
};

export default ProtectedRoute;